import { BaseLoader } from "./BaseLoader";
import { LoaderEvent } from "../events/LoaderEvent";

// TODO: test this class for correct disposing
export class FontLoader extends BaseLoader
{
    private _fontFamily: string;
    private _fontContent: string;
    private _styleTag: JQuery;

    constructor(fontFamily: string, fontContent: string)
    {
        super("");

        this._fontFamily = fontFamily;
        this._fontContent = fontContent;
    }

    getData() {
        return null;
    }

    load() {
        if(this._state == BaseLoader.STATE_LOADING)
            return;
        else if(this._state == BaseLoader.STATE_LOADED)
        {
            const self = this;
            setTimeout(function()
            {
                self.onLoaded();
            }, 0);
            return;
        }

        this._styleTag.remove();
        this._styleTag.html(this._fontContent);
        $("head").append(this._styleTag);

        const self = this;
        window["WebFont"].load({
            custom: {
                families: [this._fontFamily]
            },
            loading: function() {},
            active: function() {
                self.onLoaded();
            }
        });
    }

    dispose() {
        this._styleTag.remove();
        this._styleTag = null;

        super.dispose();
    }

    protected getResponseType(): string
    {
        throw "This method is irrelevant for this type of loader.";
    }

    protected setUpRequest(): void {
        this._styleTag = $("<style>");
    }

    protected onLoaded(event?: any)
    {
        this._state = BaseLoader.STATE_LOADED;
        this.dispatchEvent(new LoaderEvent(LoaderEvent.PROGRESS, {progress: 1, progressChange: 1}));
        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE));
    }

    protected onError(event: any)
    {
        this._state = BaseLoader.STATE_ERROR;
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}
